import { Link } from "react-router";
import { EmptyState, PageHeader } from "../components/ui";

export function NotFoundPage() {
  return (
    <div className="page">
      <PageHeader title="ページが見つかりません" />
      <EmptyState title="URLが変わったか、削除されたか、見る権限がありません" ribatan={{ pose: "lost", say: "ここ、どこだろう…" }}>
        <Link to="/">見つけるへ戻る</Link>
      </EmptyState>
    </div>
  );
}
